module.exports = __webpack_public_path__ + "81a8cf5face04e7a555951a5f78ce4d3.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/macha-panel-320.webp.png
// module id = 472
// module chunks = 0